// extracted by mini-css-extract-plugin
module.exports = {"div":"Image_div__OMRlr","img":"Image_img__YfU8f","selected":"Image_selected__3SyHm"};